import { render, staticRenderFns } from "./NumberScroll.vue?vue&type=template&id=39b1bf95&scoped=true"
import script from "./NumberScroll.vue?vue&type=script&lang=js"
export * from "./NumberScroll.vue?vue&type=script&lang=js"
import style0 from "./NumberScroll.vue?vue&type=style&index=0&id=39b1bf95&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1bf95",
  null
  
)

export default component.exports